import { convertPublicMediaPathToOutputPath } from '../../../utils/hoc/withPublicMedia/utils';
import { ifElse, insert, join, pipe, split, tail, identity } from 'ramda';
import { RouteMatcher } from '../../../utils/RouteHelpers';
import { getQuery } from '../../../monitoring/utils';
import { compact } from 'ramda-adjunct';

export const preparePathBeforeSubmit = (pathname: string = '', search: string = ''): string => {
  const { searchQuery } = getQuery(search);

  return pipe<string, string[], string[], string[], string, string>(
    split('/'),
    compact,
    ifElse<string[], string[], string[]>(() => RouteMatcher.isSearch(pathname), insert(2, searchQuery), tail),
    join('/'),
    ifElse(() => RouteMatcher.isBoard(pathname), identity, convertPublicMediaPathToOutputPath),
  )(pathname);
};
